/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { customFieldValueInputSchema } from './customFieldValueInputSchema';

export const customFieldPatchSchema = z.object({
  fieldId: z.int(),
  get fieldValue() {
    return z.array(customFieldValueInputSchema);
  },
});
